import { PropsWithChildren } from "react"
import { NavLink as ReactRouterNavLink } from "react-router-dom"
import classNames from "classnames"

interface Props extends PropsWithChildren {
  to: string
  className?: string
  activeClassName?: string
  end?: boolean
  target?: string
  rel?: string
  onClick?: () => void
}

export const NavLink = ({ to, className, activeClassName, children, onClick, end, target, rel }: Props) => {
  return (
    <ReactRouterNavLink
      to={to}
      end={end}
      target={target}
      rel={rel}
      onClick={onClick}
      className={navData => classNames(className, `${navData.isActive && activeClassName}`)}
    >
      {children}
    </ReactRouterNavLink>
  )
}
